import axios from 'axios';
axios.defaults.baseURL = import.meta.env.VITE_API_URL;
// PENTING: Disable withCredentials karena browser auto-send cookies yang corrupt
// Kita akan handle cookies secara manual di interceptor
axios.defaults.withCredentials = false;
axios.defaults.withXSRFToken = false;

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  return config;
})

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
)